const DEFAULT_FORM_DATA = {
  other: {
    numberOfFinancialDependents17Under: undefined,
    numberOfFinancialDependentsOver17: undefined,
  },
};

export default DEFAULT_FORM_DATA;
